import React, {useState} from 'react';
import mainLogoWhite from '../../img/main_logo_white.png';
import {useFilter} from '../../pages/Marketplace/FilterContext';
import './Header.scss';

const Header = () => {
    const [isNavActive, setIsNavActive] = useState(false);
    const {cartCount, homeAccToken} = useFilter();
    const toggleNavActive = () => {
        setIsNavActive(!isNavActive);
    };

    return (
        <header className="main-header">
            <div className="header-top">
                <button className="btn-burger" onClick={toggleNavActive}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
                <a href="/music" className="logo">
                    <img src={mainLogoWhite} alt="Logo"/>
                </a>
                <nav className={`navigation ${isNavActive ? 'navigation-active' : '_navigation-active'}`}>
                    <ul>
                        <li><a className="link-home" href="/music">Home</a></li>
                        {window.location.pathname === "/marketplace/" ? (
                            <li><a className="active" href="/marketplace/">Marketplace</a></li>
                        ) : (
                            <li><a href="/marketplace/">Marketplace</a></li>
                        )}
                        <li>
                            <a className="link-redeem" href={homeAccToken ? "/redeem-code" : "/login"}>Redeem</a>
                        </li>
                        <li><a href="/press_room">Press Room</a></li>
                        <li><a href="/contact_us">Contact Us</a></li>
                        {homeAccToken && <li><a href="/account">My Account</a></li>}
                        {homeAccToken ? (
                            <li><a className={`link-login ${homeAccToken ? 'active-img' : ''}`} href="/logout">Login</a></li>
                        ) : (
                            <li><a className={`link-login ${homeAccToken ? 'active-img' : ''}`} href="/login">Login</a></li>
                        )}
                    </ul>
                </nav>
                <div className="link">
                    <a href="/cart" className="btn btn-cart">Cart (<span className="cart-amount">{cartCount}</span>)</a>
                    <ul className="link-social">
                        <li><a className="link-twitter" href="https://twitter.com/iDittyCards"> </a></li>
                        <li><a className="link-facebook" href="https://www.facebook.com/idittycards"> </a></li>
                    </ul>
                </div>
            </div>
        </header>
    );
};

export default Header;
